import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedNumber } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormControl, OverlayTrigger, Popover } from 'react-bootstrap'
import { T } from 'components/components/i18n'
import { has as _has } from 'lodash'
import { addItem, addItemsGroup } from '../../../../../../actions/cart'
import { setTyre, setTyreGroup } from '../../../../../../actions/wheelBuilder'
import { CATEGORIES } from '../../../../../../helpers/categories'
import EuGrading from '../../../../EuGrading/new'
import styles from './styles.less'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck, faEdit, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import Button from '../../../../Button'
import TyreTypeIcon from '../../TyreTypeIcon'
import TestResults from '../../TestResults'
import ProductProperties from '../../ProductProperties'
import { calculatePrice } from '../../../../../../helpers/price'
import ProductInfoPopover from '../../ProductInfoPopover/v2'
import SupplierPopover from '../../SupplierPopover'
import StockAmountMessage from '../../StockAmountMessage'
import DeliveryTime from '../../../../DeliveryTime'
import { isShowBadge } from 'helpers/badge'
import Image from 'components/components/Image'
import CommentInput from 'components/components/Form/CommentInput'
import Unit from 'components/components/Cart/Unit'
import { getUsedStockInfo, getUnit } from 'helpers/order'
import { isMobile } from 'helpers/general'
import { pathTranslate } from 'helpers/routing'
import ZeroQuantityModal from 'components/components/ZeroQuantityModal'
import { NO_TRANSLATE_CLASS, NO_TRANSLATE_PROPS } from 'helpers/translation'

export class Product extends React.Component {
  constructor(props) {
    super(props)

    // NOTE: Temp solution to test how users perceive this behaviour
    //       where when USED complete wheel is low on stock (<= 4)
    //       user can only select all quantity
    const {
      isLockQuantity: isLockQuantityFront,
      lockedStockValue: lockedStockValueFront,
    } = getUsedStockInfo(
      this.props.product?.condition?.type,
      this.props.product?.stock,
      this.props.initialCount,
      this.props.overrideLock
    )

    const {
      isLockQuantity: isLockQuantityRear,
      lockedStockValue: lockedStockValueRear,
    } = getUsedStockInfo(
      this.props.product?.rear?.condition?.type,
      this.props.product?.rear?.stock,
      this.props.initialCount,
      this.props.overrideLock
    )

    this.state = {
      count: lockedStockValueFront,
      comment: '',
      countRear: lockedStockValueRear,
      commentRear: '',
      isLockQuantityFront,
      isLockQuantityRear,
      showZeroQuantityModal: false
    }
  }

  onButtonClick() {
    const {
      product,
      shop,
      cartItems,
      isWheelBuilder,
      addToCart,
      addGroupToCart,
      setTyre,
      setTyreGroup,
      category,
      isStaggeredFitment
    } = this.props
    const count = parseInt(this.state.count, 10)
    const countRear = parseInt(this.state.countRear, 10)
    const hasInvalidQuantity = isStaggeredFitment
      ? (!Number.isInteger(count) || count <= 0 || !Number.isInteger(countRear) || countRear <= 0)
      : (!Number.isInteger(count) || count <= 0)

    if (hasInvalidQuantity) {
      this.setState({ showZeroQuantityModal: true })
      return
    }

    if (!isWheelBuilder) {
      if (isStaggeredFitment) {
        addGroupToCart([
          {
            itemId: product.id,
            count,
            comment: this.state.comment,
          },
          {
            itemId: product.rear.id,
            count: countRear,
            comment: this.state.commentRear,
          }
        ], shop)
      } else {
        addToCart(product.id, count, shop, cartItems, this.state.comment)
      }
    } else if (category.id === CATEGORIES.TYRE.id) {
      if (isStaggeredFitment) {
        product.count = count
        product.comment = this.state.comment
        product.rear.count = countRear
        product.rear.comment = this.state.commecommentRearnt
        setTyreGroup([
          product, product.rear
        ])
      } else {
        setTyre(product, count, this.state.comment)
      }
    }
  }

  onCountChange(event) {
    this.setState({
      count: parseInt(event.target.value, 10)
    })
  }

  onCommentChange(event) {
    this.setState({
      comment: event.target.value
    })
  }

  onCountRearChange(event) {
    this.setState({
      countRear: parseInt(event.target.value, 10)
    })
  }

  onCommentRearChange(event) {
    this.setState({
      commentRear: event.target.value
    })
  }

  render() {
    const {
      product,
      shop,
      inProgress,
      isPair,
      isTopRank,
      isStaggeredFitment,
      campaignLabel1,
      campaignLabel2
    } = this.props

    let button
    if (!shop.prohibitPurchase)
      button = (
        <Button
          className={`${styles.buttonPair} productList_buyButton`}
          onClick={this.onButtonClick.bind(this)}
          icon={<FontAwesomeIcon icon={faShoppingCart} />}
          label={<T id="Buy" />}
          inProgress={inProgress}
        />
      )

    const listingStyle = isStaggeredFitment ? styles.productPair : styles.productSingle
    const extraStyle = isTopRank
      ? 'staggered-top-rank'
      : ((isPair && !isStaggeredFitment) || !isPair) ? 'staggered-single' : 'staggered-pair'

    const InputQuantityWrapper = (props) => {
      const { input } = props

      if (props.shouldOverlay) {
        return (
          <OverlayTrigger
            placement={isMobile() ? 'top' : 'right'}
            overlay={
              <Popover>
                <T id="This item is sold in sets." />
              </Popover>
            }
          >
            {input}
          </OverlayTrigger>
        )
      }
      return (
        <React.Fragment>
          {input}
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <li className={`${styles.product} ${listingStyle} ${extraStyle} product productList_productItem border-colored`}>
        <div className={`${styles.productItemWrapper} productList_productItemWrapper`}>
          <div className={`${styles.productItem} productItem`}>
            {!!isStaggeredFitment && (
              <span className={`background text-colored ${styles.productPositionStaggered} ${styles.productPositionFront}`}>
                <span><T id="Front" /></span>
              </span>
            )}
            {(!isStaggeredFitment && !!isPair) && (
              <div className={`${styles.productPosition}`}>
                <span className={`background text-colored ${styles.productPositionFront}`}>
                  <span><T id="Front" /></span>
                </span>
                <span className={`background text-colored ${styles.productPositionRear}`}>
                  <span><T id="Rear" /></span>
                </span>
              </div>
            )}
            {(!!campaignLabel1 || !!campaignLabel2) && (
              <div className={`${styles.campaign} border-colored text-colored`}>
                {!!campaignLabel1 && (
                  <div className={`${styles.campaignLabel} ${styles.campaignLabel1} campaignLabel1`}>
                    <span className={`background-normal ${styles.campaignLabelWrapper} campaignLabelWrapper`}>
                      {campaignLabel1}
                    </span>
                  </div>
                )}
                <div className={`${styles.campaignLabel} ${styles.campaignLabel2} campaignLabel2`}>{campaignLabel2}</div>
              </div>
            )}
            <ProductDetails
              {...this.props}
              product={product}
              key={`product_details_${product._key}`}
            />
            <div className={styles.priceExtra}>
              <ProductPriceExtra
                {...this.props}
                product={product}
                count={this.state.count}
                key={`product_price_extra_${product._key}`}
              />
            </div>
            <div className={styles.noteWrapper}>
              <FontAwesomeIcon
                icon={faEdit}
              />
              <T id="Add note">
                {
                  msg =>  (
                    <CommentInput
                      placeholder={msg}
                      className={`${styles.commentInput}`}
                      onChange={this.onCommentChange.bind(this)}
                    />
                  )
                }
              </T>
            </div>
          </div>
          {!!isStaggeredFitment && (
            <div className={`${styles.productItem} productItem`}>
              <span className={`background text-colored ${styles.productPositionStaggered} ${styles.productPositionRear}`}>
                <span><T id="Rear" /></span>
              </span>
              <ProductDetails
                {...this.props}
                product={product.rear}
                key={`product_details_${product.id}-${product.rear.id}`}
              />
              <div className={styles.priceExtra}>
                <ProductPriceExtra
                  {...this.props}
                  product={product.rear}
                  count={this.state.countRear}
                  key={`product_price_extra_${product.id}-${product.rear.id}`}
                />
              </div>
              <div className={styles.noteWrapper}>
                <FontAwesomeIcon
                  icon={faEdit}
                />
                <T id="Add note">
                  {
                    msg =>  (
                      <CommentInput
                        placeholder={msg}
                        className={`${styles.commentInput}`}
                        onChange={this.onCommentRearChange.bind(this)}
                      />
                    )
                  }
                </T>
              </div>
            </div>
          )}
        </div>
        <div className={`border-colored ${styles.orderInfo} orderInfo`}>
          <div className={`${styles.orderInfoItem} ${!!isStaggeredFitment ? styles.orderInfoItemFront : ''}`}>
            <div className={styles.priceWrapper}>
              <ProductPrice
                {...this.props}
                product={product}
                key={`product_price_${product._key}`}
              />
            </div>
            <div className={styles.quantityWrapper}>
              <span className={styles.label}><T id="Items"/></span>
              <span className={styles.input}>
                <InputQuantityWrapper
                  input={
                    <FormControl
                      type="number"
                      className={styles.commentInput}
                      name="count"
                      value={this.state.count}
                      onChange={this.onCountChange.bind(this)}
                      min="1"
                      max="99"
                      readOnly={this.state.isLockQuantityFront}
                    />
                  }
                  shouldOverlay={this.state.isLockQuantityFront}
                />
              </span>
            </div>
          </div>
          {!!isStaggeredFitment && (
            <div className={`${styles.orderInfoItem} ${styles.orderInfoItemRear}`}>
              <div className={styles.priceWrapper}>
                <ProductPrice
                  {...this.props}
                  product={product.rear}
                  key={`product_price_${product.id}-${product.rear.id}`}
                />
              </div>
              <div className={styles.quantityWrapper}>
                <span className={styles.label}><T id="Items"/></span>
                <span className={styles.input}>
                  <InputQuantityWrapper
                    input={
                      <FormControl
                        type="number"
                        className={styles.commentInput}
                        name="count"
                        value={this.state.countRear}
                        onChange={this.onCountRearChange.bind(this)}
                        min="1"
                        max="99"
                        readOnly={this.state.isLockQuantityRear}
                      />
                    }
                    shouldOverlay={this.state.isLockQuantityRear}
                  />
                </span>
              </div>
            </div>
          )}
        </div>
        <div className={styles.buttonWrapper}>
          {button}
        </div>
        </li>
        <ZeroQuantityModal
          show={this.state.showZeroQuantityModal}
          onHide={() => this.setState({ showZeroQuantityModal: false })}
        />
      </React.Fragment>
    )
  }
}

class ProductPriceExtra extends React.Component {
  render() {
    const {
      product,
      shop,
      includeVat,
      isWheelBuilder,
      cartItems,
      selectedNumberOfPcs,
      priceType,
      currency,
      selectedRim,
      count,
      overrideUnit,
    } = this.props

    let priceValue
    if (priceType === 'consumer')
      priceValue = product.consumerPrice
    else if (priceType === 'manufacturer')
      priceValue = product.manufacturerListPrice
    else
      priceValue = product.price
    const vatPercent = includeVat ? product.vatPercent : null
    priceValue = calculatePrice(priceValue, selectedNumberOfPcs, vatPercent)

    const itemsAlreadyInCart = cartItems.filter(item => item.id === product.id)
    let quantityInCartMessage
    const sum = itemsAlreadyInCart.reduce((sum, item) => (sum + item.count), 0);
    if (sum > 0)
      quantityInCartMessage = <Link to="/kassa" className={styles.quantityInCartMessage}>
        {sum}
        <T id="pcs already in cart"/>
      </Link>

    let wheelPrice
    if (isWheelBuilder && selectedRim) {
      let rimPriceValue
      if (priceType === 'consumer')
        rimPriceValue = selectedRim.consumerPrice
      else if (priceType === 'manufacturer')
        rimPriceValue = selectedRim.manufacturerListPrice
      else
        rimPriceValue = selectedRim.price

      rimPriceValue = calculatePrice(rimPriceValue, selectedNumberOfPcs, vatPercent);
      wheelPrice = (
        <div class="complete-wheel-price">
          <T id="Wheel price" />&nbsp;
          ({selectedNumberOfPcs} {!!overrideUnit && <T id={overrideUnit} />}):&nbsp;
          <FormattedNumber
            style={`currency`}
            value={rimPriceValue + priceValue}
            currency={currency}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />
        </div>
      )
    }

    return (
      <React.Fragment>
        {quantityInCartMessage}
        <div className={styles.quantityInCart}>
          {((shop.limitPurchaseQuantityToStock && product.stock < parseInt(count, 10)) || product.stock === 0) && (
            <div className={styles.limitedQuantityMessage}>
              <T id="Limited quantity available" />
            </div>
          )}
          {wheelPrice}
        </div>
      </React.Fragment>
    )
  }
}

class ProductPrice extends React.Component {
  render() {
    const {
      product,
      includeVat,
      selectedNumberOfPcs,
      priceType,
      currency,
      overrideUnit,
      unitTooltip,
    } = this.props

    let priceValue
    if (priceType === 'consumer')
      priceValue = product.consumerPrice
    else if (priceType === 'manufacturer')
      priceValue = product.manufacturerListPrice
    else
      priceValue = product.price
    const vatPercent = includeVat ? product.vatPercent : null
    priceValue = calculatePrice(priceValue, selectedNumberOfPcs, vatPercent)
    const price = (
      <FormattedNumber
        style={`currency`}
        value={priceValue}
        currency={currency}
        minimumFractionDigits={0}
        maximumFractionDigits={0}
      />
    )

    return (
      <div className={`${styles.priceInfo} productList_priceInfo`}>
        <strong className={`${styles.price} productList_price text-colored`}>
          {price}
          <span className={`${styles.pricePcs} productList_pricePcs text-normal`}>
            / {selectedNumberOfPcs === 1 ? '' : selectedNumberOfPcs}
            <Unit unit={overrideUnit} tooltip={unitTooltip} />
          </span>
        </strong>
      </div>
    )
  }
}

class ProductDetails extends React.Component {
  render() {
    const {
      product,
      shop,
      category,
      isWheelBuilder,
      isStaggeredFitment,
    } = this.props
    const _productLinkUrl = isWheelBuilder ? `/hjul/${category.slug}/${product.id}/${product.slug}` : `/${category.slug}/${product.id}/${product.slug}`
    const productLinkUrl = shop.locale === 'nb' ? pathTranslate(_productLinkUrl) : _productLinkUrl
    const imageSrc = product.image && product.image.webshop_thumb
      ? product.image.webshop_thumb
      : '/images/default-product-thumbnail.png'
      // 'https://api.eontyre.com/images/1127062/webshop_thumb.jpg'
      // '/images/default-product-thumbnail.png'

    const showBadge = isShowBadge(
      (_has(product, 'name') && product.name) || '',
      (_has(product, 'brand.name') && product.brand.name) || '',
      _has(shop, 'siteId') && shop.siteId
    )

    let productDescription
    if (shop.showFullProductDescriptionOnSearch)
      productDescription = product.description

    let stockAmount
    if (!!shop.showStockAmountsOnSearch) {
      const stockAmountMessage = <StockAmountMessage stock={product.stock} showActualStockAmounts={shop.showActualStockAmounts} />
      stockAmount = <div>{stockAmountMessage}</div>
    }

    let supplier
    if (!!shop.showSupplierInSearchResults) {
      const productSource = product.supplier.id ? product.supplier : product.location
      if(!productSource.hideIt)
        supplier = <SupplierPopover supplier={product.supplier} supplierNameComponent={productSource.name} />
    }

    let delivery, deliveryClass
    switch(product.estimatedDeliveryType) {
       case 0:
       case 5:
         deliveryClass = 'text-danger font-weight-bold'
         break
       case 1:
         deliveryClass = 'text-success font-weight-bold'
         break
       case 2:
         deliveryClass = 'text-info font-weight-bold'
         break
       case 3:
         deliveryClass = 'text-warning font-weight-bold'
         break
       default:
         deliveryClass = ''
    }
    if (product.deliveryTime && !product.deliveryTime.hideIt) {
      if (shop.deliveryDisplayMode === 1) {
        let deliveryTime
        deliveryTime = <DeliveryTime deliveryInfo={product.deliveryTime} />
        delivery = <div className={deliveryClass}>{deliveryTime}</div>
      } else {
        delivery = (
          <FontAwesomeIcon
            className={deliveryClass}
            icon={faTruck}
          />
        )
      }
    }

    let euGrading, type, testResults
    euGrading = <EuGrading product={product} />
    type = <TyreTypeIcon product={product}/>
    testResults = <TestResults product={product}/>

    let bonus
    if (product.bonus !== 0)
      bonus = (
        <div>
          <FormattedNumber
            style={`percent`}
            value={product.bonus/100}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />&nbsp;<T id="bonus"/>
        </div>
      )

    const productTitle = [
      <div {...NO_TRANSLATE_PROPS} className={`${styles.productTitleWrapper} ${NO_TRANSLATE_CLASS}`}>
        <Link
          to={productLinkUrl}
          className={`${styles.productTitle} ${styles.productTitlePair} text-colored`}
          key="product-name"
          title={`${product.brand && product.brand.name} ${product.model && product.model.name}`}
        >
          <span>
            <span>{product.brand && product.brand.name}</span>
          </span>
          <span>
            <em>{product.model && product.model.name}</em>
          </span>
        </Link>
        <div className={styles.productDimensions} key="product-description">
          <div>
            {product.attrs && product.attrs.dimension}
            {product.attrs && product.attrs.treadDepths && ` (${product.attrs.treadDepths})`}
          </div>
          {!!(product?.attrs?.dotMark) && (
            <div>
              {`DOT:${product.attrs.dotMark}`}
            </div>
          )}
        </div>
      </div>
    ]

    const tyreType = product?.attrs?.tyreType?.id > 2
      ? 'winter'
      : product?.attrs?.tyreType?.id

    return (
      <React.Fragment>
        <div className={styles.productMainInfoWrapper}>
          <Link to={productLinkUrl} className={styles.productThumbnail}>
            <Image src={imageSrc} width="120px" height="120px" defaultImage="/images/default-product-thumbnail.png" />
            <div className={`${styles.typeBadge} tyreType_${tyreType}`}>{type}</div>
            {showBadge && <img className={styles.productBadge} src={`/images/badge/michelin.png`} width="40px" alt="Michelin" />}
          </Link>
          <div className={styles.productMainDetailsWrapper}>
            <ProductInfoPopover product={product} productTitleElements={productTitle} />
            <div className={`${styles.productProperties} productProperties`}>
              <ProductProperties product={product} condition={product.condition}/>
            </div>
          </div>
          <div className={styles.topItem}>{euGrading}</div>
          <div className={styles.testRatings}>
            {testResults}
          </div>
        </div>
        <div className={`${styles.productDetailsWrapper}`}>
          <div className={styles.productDescription}>
            {delivery}
            {supplier}
            {bonus}
            {stockAmount}
            {productDescription}
          </div>
          <div className={styles.comment}>{product.comment}</div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => {
  const { isStaggeredFitment } = state.search.resultsByCategory.tyre
  // NOTE: Even though the search parameters/criteria are staggered fitment, but
  //       some of the results might yield same product Id
  const _isStaggeredFitment = isStaggeredFitment && !props.product.isSameWithRear
  const overrideInitialCount = state.shop.topBrandsConfig?.['quantity']?.['tyre']?.initial
  const overrideUnit = state.shop.topBrandsConfig?.['quantity']?.['tyre']
    ? getUnit(
        {
          ...state.shop.topBrandsConfig['quantity']['tyre'],
          description: props?.product?.description
        },
        state.shop.quantityConfig.tyre.unit
      )
    : state.shop.quantityConfig.tyre.unit
  const overrideLock = !!state.shop.topBrandsConfig?.['quantity']?.['tyre']?.no_locked
  const maxCount = overrideInitialCount
    ? parseInt(overrideInitialCount, 10)
    : (_isStaggeredFitment ? 2 : 4);

  return {
    includeVat: state.price.includeVat,
    selectedNumberOfPcs: state.price.selectedNumberOfPcs,
    priceType: state.price.priceType,
    shop: state.shop,
    user: state.user.user,
    cartItems: state.cart.items,
    category: state.categories.activeCategory,
    isWheelBuilder: state.wheelBuilder.showWheelProgress,
    selectedRim: state.wheelBuilder.rim,
    currency: state.intl.currency,
    inProgress: state.cart.updateInProgress[props.product.id],
    overrideLock,
    overrideUnit,
    unitTooltip: state.shop.quantityConfig.tyre.tooltip,
    initialCount: state.shop.limitPurchaseQuantityToStock
      ? Math.min(props.product.stock, maxCount) : maxCount,
    isStaggeredFitment: _isStaggeredFitment,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  addToCart: (itemId, count, shop, cartItems, comment) => addItem(itemId, count, shop, cartItems, comment),
  addGroupToCart: (items, shop) => addItemsGroup(items, shop),
  setTyre: (product, count, comment) => setTyre(product, count, comment),
  setTyreGroup: (items) => setTyreGroup(items)
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Product)
